export default "__VITE_ASSET__nmnHlTMY__"